import GetAvailability from "@/types/clients/esquire/requests/booking/get-availability";
import GetExtensionData from "@/types/clients/esquire/requests/booking/get-extension-data";
import ExtendReservation from "@/types/clients/esquire/requests/payment/extend-reservation";
import ExtendReservationData, {
  IContractDetails
} from "@/types/clients/esquire/requests/payment/extend-reservation-data";
import esquire from "@/types/clients/esquire";

export const getAvailabilityRequest = new GetAvailability(esquire);
export const getExtensionDataRequest = new GetExtensionData(esquire);
export const extendReservationRequest = new ExtendReservation(esquire);
export class ReservationService {
  static async getAvailabilities(reservationId: string, contractIds: Array<string>): Promise<Array<string>> {
    return await getAvailabilityRequest.send(reservationId, contractIds) ?? [];
  }

  static async fetchExtensionData(reservationId: string, contractIds: Array<string>, selectedDate: string) {
    return await getExtensionDataRequest.send(reservationId, contractIds, selectedDate);
  }

  static async extendReservation(reservationId: string, selectedContractIds: Array<string>, selectedDate: string, contractDetails: Record<string, IContractDetails>) {

    const payload = new ExtendReservationData({
      reservation_id: reservationId,
      contract_ids: selectedContractIds,
      new_departure_date: selectedDate,
      contract_details: contractDetails
    });

    return await extendReservationRequest.send(payload);
  }

}
